module.exports = __webpack_public_path__ + "img/intent_9.5553c11b.png";